export default function InitSondernavigation() {
    const sidebars = document.querySelectorAll('.sondernavigation');

    if (!sidebars.length) {
        return;
    }

    const footer = document.querySelector('footer');

    sidebars.forEach((sidebar) => {
        let naturalTop = null;
        // the last document-coordinate Y position the sidebar is allowed to reach before it
        // has to stop (so it never overlaps the footer) — recomputed on resize since both the
        // sidebar's own height and the footer's position can change
        let stopTop = null;

        // browsers auto-compute an absolutely positioned element's "static position" from
        // where it would render in normal flow — but only while it isn't already fixed/stopped
        const measureNaturalTop = () => {
            sidebar.classList.remove('sondernavigation--fixed', 'sondernavigation--stopped');
            sidebar.style.top = '';
            naturalTop = sidebar.getBoundingClientRect().top + window.scrollY;
            if (footer) {
                const footerTop = footer.getBoundingClientRect().top + window.scrollY;
                const gapAboveFooter = 40;
                stopTop = footerTop - sidebar.offsetHeight - gapAboveFooter;
            }
        };

        const updateFixedState = () => {
            if (naturalTop === null) {
                return;
            }
            const headerHeight = parseFloat(
                getComputedStyle(document.documentElement).getPropertyValue('--header-height')
            ) || 150;
            const fixedTop = window.scrollY + headerHeight + 24;

            if (fixedTop < naturalTop) {
                // still above its own natural position — plain in-flow, no override needed
                sidebar.classList.remove('sondernavigation--fixed', 'sondernavigation--stopped');
                sidebar.style.top = '';
            } else if (stopTop === null || fixedTop < stopTop) {
                // normal case: pinned to the header like `position: sticky` would do. Clearing
                // the inline `top` here matters — without it, scrolling back up out of the
                // "stopped" state below would leave that state's inline top (a large
                // document-coordinate value) in place, which wins over `--fixed`'s own `top`
                // by specificity and pins the sidebar off-screen
                sidebar.classList.add('sondernavigation--fixed');
                sidebar.classList.remove('sondernavigation--stopped');
                sidebar.style.top = '';
            } else {
                // about to overlap the footer — park it at stopTop (a document-coordinate,
                // not viewport-relative, value) so it scrolls away with the page from here
                // instead of staying fixed on top of the footer
                sidebar.classList.remove('sondernavigation--fixed');
                sidebar.classList.add('sondernavigation--stopped');
                sidebar.style.top = stopTop + 'px';
            }
        };

        // the sidebar is width:fit-content (sized to its widest pill, not a fixed col-3), so
        // the following module needs the real rendered width to align its own margin-left —
        // set on the root because CSS custom properties don't cascade sideways to siblings.
        // ResizeObserver (not just a resize listener) because the width can also shift after
        // load from web-font swap-in, which changes text metrics without firing 'resize'
        const measureWidth = () => {
            document.documentElement.style.setProperty('--sondernav-actual-width', sidebar.offsetWidth + 'px');
        };

        const remeasureAll = () => {
            measureNaturalTop();
            updateFixedState();
            measureWidth();
        };

        remeasureAll();

        if (typeof ResizeObserver !== 'undefined') {
            new ResizeObserver(measureWidth).observe(sidebar);
            // stopTop depends on the footer's document position, which shifts as images/hero
            // content above it finish loading and grow the page — a plain 'resize' listener
            // only catches the *viewport* changing, not the *document* growing underneath it,
            // so on first load stopTop could get measured against a footer that hasn't reached
            // its final position yet, parking the sidebar way too early
            new ResizeObserver(remeasureAll).observe(document.body);
        }

        // belt-and-braces alongside the ResizeObserver above: images without explicit
        // width/height attributes only finish affecting layout once they've actually decoded
        window.addEventListener('load', remeasureAll);

        window.addEventListener('scroll', updateFixedState, { passive: true });
        window.addEventListener('resize', remeasureAll, { passive: true });
    });
}
